import { Box, Grid, Paper, Tab, Tabs, useMediaQuery } from '@mui/material';
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import EmailTemplatePage from './EmailTemplatePage';
import { EmailTemplateType } from '../../types/EmailTemplateType';

const EmailTemplateHomePage = () => {
  const [tabValue, setTabValue] = useState<number>(0);
  const isSmallScreen = useMediaQuery('(max-width:600px)');
  const parkingEnabled = useSelector(
    (state: any) => state.app.featureFlags?.parkingEnabled
  );

  const tabs = useMemo(
    () =>
      [
        {
          label: 'Bejelentés',
          type: EmailTemplateType.ReportEmail,
        },
        {
          label: 'Értesítés',
          type: EmailTemplateType.NotificationEmail,
        },
        parkingEnabled
          ? {
              label: 'Parkolás',
              type: EmailTemplateType.ParkingEmail,
            }
          : null,
      ].filter(Boolean) as { label: string; type: EmailTemplateType }[],
    [parkingEnabled]
  );

  useEffect(() => {
    const storedTabValue = localStorage.getItem('EmailTemplateTab');
    if (storedTabValue) {
      const parsed = parseInt(storedTabValue, 10);
      if (!Number.isNaN(parsed) && parsed >= 0 && parsed < tabs.length) {
        setTabValue(parsed);
      } else {
        setTabValue(0);
        localStorage.setItem('EmailTemplateTab', '0');
      }
    }
  }, [tabs.length]);

  useEffect(() => {
    if (tabValue >= tabs.length) {
      setTabValue(0);
      localStorage.setItem('EmailTemplateTab', '0');
    }
  }, [tabValue, tabs.length]);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    localStorage.setItem('EmailTemplateTab', newValue.toString());
  };

  const activeType = tabs[tabValue]?.type ?? EmailTemplateType.ReportEmail;

  return (
    <Paper>
      <Grid
        container
        sx={{
          p: 3,
        }}
      >
        <Grid size={12}>
          <Box sx={{ width: '100%' }}>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                pb: 2,
                maxWidth: isSmallScreen ? '280px' : '100%',
              }}
            >
              <Tabs
                value={Math.min(tabValue, tabs.length - 1)}
                onChange={handleChange}
                sx={{
                  maxWidth: isSmallScreen ? '280px' : '100%',
                  overflowX: 'scroll',
                }}
                allowScrollButtonsMobile
                scrollButtons="auto"
                variant="scrollable"
                slotProps={{
                  indicator: { style: { background: '#1976d2' } },
                }}
              >
                {tabs.map((tab) => (
                  <Tab
                    key={tab.type}
                    label={tab.label}
                    sx={{ fontWeight: 'bold' }}
                  />
                ))}
              </Tabs>
            </Box>
            <EmailTemplatePage emailTemplateType={activeType} />
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default EmailTemplateHomePage;
